export default {
    msg: {
        /* 翻译 -------------------------------------开始 */
        // 通用
        "空": "فارغ",
        "暂无数据": "لا توجد بيانات حاليًا",
        "安装包列表": "قائمة حزم التثبيت",
        "显示器列表": "قائمة الشاشات",
        "设置-配置文件": "الإعدادات - ملف التعريف",
        "用户管理": "إدارة المستخدمين",
        "操作记录": "سجل العمليات",
        "退出": "خروج",
        "共": "المجموع",
        "页": "صفحة",
        "前往": "اذهب إلى",
        "上一页": "الصفحة السابقة",
        "下一页": "الصفحة التالية",
        "请输入前往页数": "أدخل رقم الصفحة المراد الانتقال إليها",
        "用户配置": "تهيئة المستخدم",
        "语言模式": "وضع اللغة",
        "头像": "صورة الملف الشخصي",
        "请输入x": "أدخل {param}",
        "请选择x": "اختر {param}",
        "原密码": "كلمة المرور القديمة",
        "新密码": "كلمة المرور الجديدة",
        "确认新密码": "تأكيد كلمة المرور الجديدة",
        "输入的两次密码不一致": "كلمتا المرور غير متطابقتين",
        "请输入确认新密码，密码与新密码一致": "أدخل تأكيد كلمة المرور الجديدة، يجب أن تكون متطابقة لكلمة المرور الجديدة",
        "请求参数不正确:密码长度为 8-16 位": "البيانات المدخلة غير صحيحة: يجب أن يتراوح طول كلمة المرور بين 8 و16 حرفًا",
        "联想隐私声明": "بيان الخصوصية الخاص بـ Lenovo",
        "联想软件许可协议": "اتفاقية ترخيص البرامج الخاصة بـ Lenovo",
        "第三方通知": "إشعار الأطراف الثالثة",
        "修改密码": "تغيير كلمة المرور",
        "修改个人信息": "تعديل المعلومات الشخصية",
        "成功退出": "تم الخروج بنجاح",
        "管理员": "مدير",
        "普通用户": "مستخدم عادي",
        "机型": "نوع الجهاز",
        "确认删除此信息吗？": "هل أنت متأكد من حذف هذه المعلومات؟",
        "请输入新密码，密码由大写字母，小写字母，数字，特殊字符组成，且至少包3种": "أدخل كلمة المرور الجديدة، يجب أن تتكون من الحروف الكبيرة والصغيرة والأرقام والرموز الخاصة، ويجب أن تحتوي على ثلاثة أنواع على الأقل",
        "提示": "تنبيه",
        "确 定": "تأكيد",
        "取 消": "إلغاء",
        "删除成功": "تم الحذف بنجاح",
        "修改成功": "تم التعديل بنجاح",
        "请选择正确的文件类型": "اختر نوع الملف الصحيح",
        "上传文件大于100MB，请重新选择": "حجم الملف المرفق أكبر من 100 ميجابايت، يرجى اختيار ملف آخر",
        "数据正在处理，请勿重复提交": "جارٍ معالجة البيانات، يرجى عدم إعادة الإرسال!",
        "当前登录状态已过期，请重新登录": "انتهى وقت تسجيل الدخول الحالي، يرجى تسجيل الدخول مرة أخرى!",
        "网络请求地址不正确": "عنوان طلب الشبكة غير صحيح!",
        "服务器发生未知错误": "حدث خطأ غير معروف في الخادم!",
        "发生未知错误": "حدث خطأ غير معروف!",
        "请求服务超时,可能没有网络，请重新操作": "انتهت مدة طلب الخدمة، قد لا يكون هناك اتصال بالإنترنت، يرجى إعادة المحاولة!",
        "非法请求头": "رأس الطلب غير صالح!",
        "未能连接至服务器": "لم يتم الاتصال بالخادم",
        "当前可能处于网络未连接状态": "ربما تكون في حالة عدم الاتصال بالشبكة",
        "没有找到相关设备": "لم يتم العثور على الجهاز ذي الصلة",
        "设备中预升级组件未找到": "لم يتم العثور على مكونات الترقية الأولية في الجهاز",
        "安装组件FWID未找到": "لم يتم العثور على FWID لمكون التثبيت",
        "升级信息设置失败": "فشل إعداد معلومات الترقية",
        "指定更新设置失败": "فشل إعداد التحديث المحدد",
        "更新包安装失败": "فشل تثبيت حزمة التحديث",
        "设备句柄获取失败": "فشل الحصول على معرف الجهاز",
        "升级设备不匹配": "أجهزة الترقية غير متطابقة",
        "无法安装:设备中没有找到预升级组件": "لا يمكن التثبيت: لم يتم العثور على مكونات الترقية الأولية في الجهاز",
        "无法安装:组件中FWID不匹配": "لا يمكن التثبيت: FWID للمكون غير متطابق",
        "无法安装:未找到升级匹配的显示器": "لا يمكن التثبيت: لم يتم العثور على شاشة متوافقة للترقية",
        "显示器不存在": "الشاشة غير موجودة",
        "命令已经下发": "تم إرسال الأمر بالفعل",
        "组不存在": "المجموعة غير موجودة",
        "命令不存在": "الأمر غير موجود",
        "设置不存在": "الإعداد غير موجود",
        "设置详情不存在": "تفاصيل الإعداد غير موجودة",
        "升级包不存在": "حزمة الترقية غير موجودة",
        "升级包记录不存在": "سجل حزمة الترقية غير موجود",
        "密码格式不正确，密码长度必须在8到30个字符之间": "تنسيق كلمة المرور غير صحيح، يجب أن يتراوح طول كلمة المرور بين 8 و30 حرفًا",
        "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型": "تنسيق كلمة المرور غير صحيح، يجب أن تحتوي كلمة المرور على ثلاثة أنواع على الأقل من الحروف الكبيرة والصغيرة والأرقام والرموز الخاصة",
        "参数为空": "البيانات فارغة",
        "升级时间不能为空": "لا يمكن ترك وقت الترقية فارغًا",
        "升级时间格式不正确,不能小于当前时间或超过当前时间30天": "تنسيق وقت الترقية غير صحيح، لا يمكن أن يكون أقل من الوقت الحالي أو يتجاوزه بمدة تزيد عن 30 يومًا",
        "上传文件为空": "الملف المرفق فارغ",
        "上传文件格式不正确,文件格式只能为zip/exe/dmg/app": "تنسيق الملف المرفق غير صحيح، يجب أن يكون تنسيق الملف zip أو exe أو dmg أو app",
        "上传文件格式不正确,文件不能没有后缀": "تنسيق الملف المرفق غير صحيح، يجب أن يكون للملف امتداد",
        "登录失败，账号密码不正确": "فشل تسجيل الدخول، اسم المستخدم أو كلمة المرور غير صحيحة",
        "日期": "التاريخ",
        "时间": "الوقت",
        "此操作将永久删除当前数据, 是否继续?": "ستحذف هذه العملية البيانات الحالية نهائيًا، هل تريد المتابعة؟",
        "请先选中一项再删除": "يرجى تحديد عنصر واحد على الأقل قبل الحذف",
        "开始下载": "开始下载",
        "密码错误": "密码错误",
        "修改密码成功": "修改密码成功",
        "正在下载文件中": "正在下载文件中...",
        "显示器id或组id为空": "显示器id或组id为空",
        "升级包记录id为空": "升级包记录id为空",
        "用户名已存在": "用户名已存在",
        "该显示器设置命令正在执行中，请等待10s后，再进行新的设置": "该显示器设置命令正在执行中，请等待10s后，再进行新的设置",
        "关闭": "关闭",
        "角色不存在，无法修改角色": "角色不存在，无法修改角色",
        "未知命令": "未知命令",
        "访问令牌已过期": "访问令牌已过期",
        "请求参数不正确:": "请求参数不正确:",
        "无效的刷新令牌": "无效的刷新令牌",
        "请求参数缺失:": "请求参数缺失:",
        "请求参数类型错误:": "请求参数类型错误:",
        "请求参数不正确:": "请求参数不正确:",
        "请求地址不存在:": "请求地址不存在:",
        "请求方法不正确:": "请求方法不正确:",
        // 登录
        "登录": "تسجيل الدخول",
        "账号": "حساب",
        "密码": "كلمة المرور",
        "升级失败": "فشل التحديث",
        "重置密码": "إعادة تعيين كلمة المرور؟",
        "输入字符在x个字符以内": "أدخل أقل من {param} حرفًا",
        "登录成功": "تم تسجيل الدخول بنجاح",
        "请联系管理员，进行密码重置": "يرجى الاتصال بالإدارة لإعادة تعيين كلمة المرور",
        "重试超过5次，请30分钟后再试": "重试超过5次，请30分钟后再试",
        // 显示器列表
        "请输入型号/主机名/固件版本号": "请输入型号/主机名/固件版本号",
        "创建组": "创建组",
        "删除组": "删除组",
        "显示列": "显示列",
        "折叠": "折叠",
        "展开": "展开",
        "移动组": "移动组",
        "导出": "导出",
        "开启电源": "开启电源",
        "关闭电源": "关闭电源",
        "屏幕锁定": "屏幕锁定",
        "屏幕解锁": "屏幕解锁",
        "设置": "设置",
        "导出设置配置文件": "导出设置配置文件",
        "升级": "升级",
        "删除显示器": "删除显示器",
        "设备总数量": "设备总数量",
        "设备选中量": "设备选中量",
        "请选择更新包": "请选择更新包",
        "更新包名": "更新包名",
        "更新时间": "更新时间",
        "应用于同型号显示器": "应用于同型号显示器",
        "时间": "时间",
        "显示设置": "显示设置",
        "全选": "全选",
        "设置配置文件": "设置配置文件",
        "文件名": "文件名",
        "组": "组",
        "显示器型号": "显示器型号",
        "特殊ID": "特殊ID",
        "主机名称": "主机名称",
        "主机状态": "主机状态",
        "显示器状态": "显示器状态",
        "锁定状态": "锁定状态",
        "升级进度": "升级进度",
        "创建设置": "创建设置",
        "提示信息": "提示信息",
        "使用时长": "使用时长",
        "超频": "超频",
        "操作成功": "操作成功",
        "请先保存数据": "请先保存数据",
        "请先选中组或显示器": "请先选中组或显示器",
        "未分组无法修改": "未分组无法修改",
        "取消全选": "取消全选",
        "请选中GAMMA节点标签的值": "请选中GAMMA节点标签的值",
        "未分组": "未分组",
        "离线": "离线",
        "在线": "在线",
        "开机": "开机",
        "关机": "关机",
        "锁定": "锁定",
        "未锁定": "未锁定",
        "未连接": "未连接",
        "连接": "连接",
        "设置开始的升级时间": "设置开始的升级时间",
        "现在": "现在",
        "设置升级模式": "设置升级模式",
        "交互模式": "交互模式",
        "静默模式": "静默模式",
        "在这种模式下，用户将会看到显示器固件更新界面，需要用户确认，更新才会进行。用户有两次选择延迟执行的机会，两次延退过后，将强制执行更新。": "在这种模式下，用户将会看到显示器固件更新界面，需要用户确认，更新才会进行。用户有两次选择延迟执行的机会，两次延退过后，将强制执行更新。",
        "在这种模式下，当显示器在线时，新的圆件会以后台的方式立即更新到显示器，用户看不到任何界面，但是新的同件直到显示器重启后才会生效。显示器重启大概需要几秒钟的时间，它不会影响用户电脑上当前进行的任务。": "在这种模式下，当显示器在线时，新的圆件会以后台的方式立即更新到显示器，用户看不到任何界面，但是新的同件直到显示器重启后才会生效。显示器重启大概需要几秒钟的时间，它不会影响用户电脑上当前进行的任务。",
        "请求参数不正确": "请求参数不正确",
        "账号未登录": "账号未登录",
        "请根据您的企业使用显示器的实际情况，选择您期望的显示器重启时机。": "请根据您的企业使用显示器的实际情况，选择您期望的显示器重启时机。",
        "您点击的仍是设备现属组，若要移动，请选其他组。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "请输入组名称": "请输入组名称",
        "应用设置配置文件": "应用设置配置文件：",
        "有新版本，可以去升级": "有新版本，可以去升级",
        "更新完立即重启": "更新完立即重启",
        "显示器进入休眠状态时重启": "显示器进入休眠状态时重启",
        "当显示器断开和所有的PC连接时重启": "当显示器断开和所有的PC连接时重启",
        "请输入机型名称": "请输入机型名称",
        "创建升级任务": "创建升级任务",
        "升级任务列表": "升级任务列表",
        "取消全部": "取消全部",
        "查看详情": "查看详情",
        "升级详情": "升级详情",
        "升级模式": "升级模式",
        "升级的创建时间": "升级的创建时间",
        "升级的开始时间": "升级的开始时间",
        "确认取消全部任务么？": "确认取消全部任务么？",
        "确认取消此任务么？": "确认取消此任务么？",
        "确认要删除选中的显示器吗？": "确认要删除选中的显示器吗？",
        "确认要删除所有显示器吗？": "确认要删除所有显示器吗？",
        "确认删除此信息吗（未分组无法删除）？": "确认删除此信息吗（未分组无法删除）？",
        "提示：显示器设置中若某选项变灰，有可能该选项是被其它选项的设置所制约，可以尝试改变其他设置以取消制约。": "提示：显示器设置中若某选项变灰，有可能该选项是被其它选项的设置所制约，可以尝试改变其他设置以取消制约。",
        "WebSocket 链接已断开，重连中...": "WebSocket 链接已断开，重连中...",
        "WebSocket 链接已重连成功！": "WebSocket 链接已重连成功！",
        "上一设置正在执行中，请等待数值变化后，再进行新的设置": "上一设置正在执行中，请等待数值变化后，再进行新的设置",

        "Ebook": "电子书",
        "largest": "最大",
        "Turn off auto mode": "关闭自动模式",

        "minimum": "الحد الأدنى",
        "恢复出厂设置": "اعادة ضبط اعدادات المصنع",
        "色温色域": "‏التدرج اللوني و درجة حرارة اللون",
        "Panel native": "عرض أصلي",
        "Neutral(7500K)": "حيادي",
        "Reddish(6500K)": "دافئ",
        "Bluish(9300K)": "بارد",
        "Neutral": "حيادي",
        "Reddish": "دافئ",
        "Bluish": "بارد",
        "Low Blue Light": "ضوء أزرق منخفض",
        "Custom 1": "تعديل 1",
        "Custom 2": "تعديل 2",
        "Custom 3": "تعديل 3",
        "场景模式": "وضع السيناريو",
        "输入信号":"‏إشارة الفيديو",
        "游戏模式": "وضع اللعبة",
        "Off": "ذ",
        "off": "ذ",
        "Game 1": "اللعبة1",
        "Game 2": "اللعبة2",
        "响应时间": "وقت الاستجابة",
        "Normal": "عادي",
        "Extreme": "أقصى",
        "Level 1": "المستوى 1",
        "Level 2": "المستوى 2",
        "Level 3": "المستوى 3",
        "Level 4": "المستوى 4",
        "Level 5": "المستوى 5",
        "LAN指示灯": 'مؤشر LAN',
        'linked': 'متصل ',
        'nolink': 'غير متصل ',
        'blinking': 'جاري الإتصال',
        "亮度": "التباين",
        "对比度": "السطوع",
        "智能感光": "مستشعر الإضاءة الذكية",
        "音量调节": "التحكم في مستوى الصوت",
        "USB模式": "‏تحديد USB",
        "DP模式": "‏تحديد DP",
        "显示比例": "‏النسبة الباعية",
        "智能交通灯": "‏إشارة ضوئية",
        "菊花链": "سلسلة الأقحوان",
        "动态对比度": "‏تباين ديناميكي",
        "智能能源": "‏طاقة ذكية",
        "智能音频": "الصوت الذكي",
        "距离检测": "تحذير بشأن المسافة",
        "环境光检测": "اكتشاف الضوء المحيط",
        "开启环境光检测": "تمكين اكتشاف الضوء المحيط",
        "触摸唤醒": "ميزة الإيقاظ باللمس",
        "硬分屏": "تقسيم الشاشة",
        "人脸追踪": "ميزة تعقب الوجه",
        "音频智能开关": "مفتاح الصوت الذكي",
        "自动警示": "تنبيه تلقائي",
        "KVM切换": "‏مفتاح KVM",
        "KVM（键盘、显示器、鼠标）切换功能可以使用两台电脑使用一条显示器、键盘和鼠标，打开同时切换显示器、键盘鼠标功能，如果关闭此功能，则仅切换键盘和鼠标": "يُمكّن مفتاح KVM (لوحة المفاتيح والفيديو والماوس) جهازي حاسوب من استخدام مجموعة واحدةمن الشاشة ولوحة المفاتيح والماوسقم بتمكين تبديل الفيديو ولوحة المفاتيح والماوس في نفس الوقت.وفي حالة تم تعطيله ، قم فقط بتبديل لوحة المفاتيح والماوس",
        "久坐提醒": "تذكير بالجلوس",
        "Gaming": "اللعب",
        "颜色调整": "‏ضبط اللون",
        "序列号": "الرقم التسلسلي",
        "固件版本号": "نسخة برنامج ثابت",
        "选择响应时间等级": "حدد مستوى وقت الاستجابة",
        "启用菊花链": "تمكين سلسلة الأقحوان",
        "智能交通灯是一个请勿打扰灯，帮助降低干扰": "إشارة المرور الذكية عبارة عن ضوء غير مزعج ، مما يساعد على تقليل التشتت",
        "启用/禁用音频智能开关": "تمكين/تعطيل ميزة الصوت الذكي",
        "自动警示功能指示显示器上的摄像头/麦克风是否正在被使用": "تشير ميزة التنبيه التلقائي إلى ما إذا كانت الكاميرا/المايك قيد الإستخدام على الشاشة",
        "开启距离检测": "تمكين التحذير بشأن المسافة",
        "打开或关闭人脸追踪功能": "تمكين/تعطيل ميزة تعقب الوجه",
        "开启久坐提醒": "تمكين التذكير بالجلوس",
        "智能音频技术帮助你专注显示器正前方的声音，减少环境噪音，提高声音清晰度": "تتيح لك تقنية الصوت الذكي التركيز على الصوت أمامك لتحسين وضوح الصوت",
        "智能能源技术通过人体传感器来帮助你自动管理显示器能源消耗": "تقوم تقنية الطاقة الذكية تلقائيًا بإدارة استهلاك الطاقة بواسطة مستشعر الكشف البشري",
        "硬分屏帮助你用一根线实现PBP功能": "يمكن تطبيق ميزة PBP عن طريق كابل واحد فقط",
        "启用/禁用vPro功能": "تمكين/تعطيل ميزة vPro في الشاشة",
        "通过触摸屏幕唤醒系统": "إيقاظ النظام بواسطة لمس الشاشة",
        "为每台PC设置输入信号源和USB源": "اضبط مصدر الفيديو ومصدر USB (المستخدم بواسطة لوحة المفاتيح والماوس)لكل حاسوب",
        "eKVM让您只需要同时按下鼠标的左右键，即可切换USB信号源": "eVKM يتيح لك إمكانية الوصول الفوري لمصدرين من أجهزة الكمبيوتر عن طريق النقر على زري الماوس الأيمن والأيسر معًا",
        "始终允许USB充电": "تمكين شحن USB دائمًا",
        "选择DP版本": "حدد إصدار DP",
        "usb充电": "‏شحن USB",
        '电脑': "الحاسوب",
        "双击CTRL键": "انقر مرتين على CTRL",
        "Full Screen": "شاشة كاملة",
        "Original AR": "نسبة العرض للارتفاع في الصورة الأصلية",
        "No scaling": "لا يوجد تحجيم",
        "On": "On",
        "on": "On",
        "Keyboard On": "استخدم لوحة المفاتيح",
        "Mouse On": "استخدم الماوس",
        "Image Creation": "إنشاء الصورة",
        "Digital Cinema": "السينما الرقمية",
        "Video Creation": "إنشاء الفيديو'",
        "Web Browsing": "تصفح الويب",
        "Professional Image": "صورة احترافية",
        "DisplayPort": "DisplayPort",
        "Auto": "تلقاءي",
        "auto": "تلقاءي",
        "Close PIP, PBP": "ذ",
        // 安装包列表
        "刷新": "刷新",
        "搜索": "搜索",
        "记录": "记录",
        "用户名": "用户名",
        "上传时间": "上传时间",
        "增加配置": "增加配置",
        "最新更新包": "最新更新包",
        "上传更新包": "上传更新包",
        "上传": "上传",
        "大小": "大小",
        "上传成功": "上传成功",
        "下载成功": "下载成功",
        "刷新成功": "刷新成功",
        "升级包与机型不匹配": "升级包与机型不匹配",
        // 设置-配置文件

        // 用户管理
        "编辑": "编辑",
        "保存": "保存",
        "删除": "删除",
        "添加": "添加",
        "密码重置": "密码重置",
        "序号": "序号",
        "全名": "全名",
        "角色": "角色",
        "创建日期": "创建日期",
        "操作": "操作",
        "该用户的初始密码为": "该用户的初始密码为 ",
        "密码已经重置为": "密码已经重置为：",
        "请求参数不正确:用户名由 数字、字母 组成": "请求参数不正确:用户名由 数字、字母 组成",
        "请求参数不正确:用户名长度为 4-30 个字符": "请求参数不正确:用户名长度为 4-30 个字符",
        // 操作记录
        "安装包": "安装包",
        "操作日期": "操作日期",
        "操作内容": "操作内容",
        "操作人": "操作人",
        /* 翻译 -------------------------------------结束 */

        /* 机器翻译、不翻译 -------------------------------------开始 */
        "分页组件": "分页组件",
        "快速翻页": "快速翻页",
        "当前页": "当前页",
        "确定": "确 定",
        "取消": "取 消",
        "确 定": "确 定",
        "取 消": "取 消",
        "标题": "标题",
        "详细信息": "详细信息",
        "这是扩展区域": "这是扩展区域",
        "设置显示列": "设置显示列",
        "上传文件": "上传文件",
        "下拉展开": "下拉展开",
        "default": "默认",
        "默认信息": "默认信息",
        // aria-label
        "个人中心": "个人中心",
        "个人中心图片按钮": "个人中心图片按钮",
        "可展开区域": "可展开区域",
        "更新包表格": "更新包表格",
        "这是表格标头": "这是表格标头",
        "这是表格内容": "这是表格内容",
        "用户列表表格": "用户列表表格",
        "上下翻页": "上下翻页",
        "操作记录表格": "操作记录表格",
        "OSD升级详情": "OSD升级详情",
        /* 机器翻译、不翻译 -------------------------------------结束 */

        /* 固定翻译 -------------------------------------开始 */
        "8": "8",
        "20": "20",
        "250": "250",
        'Lenovo': 'Lenovo',
        'Display Fleet Manager': 'Display Fleet Manager',
        "高动态范围": "HDR",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gamma": "Gama",
        "PiP/PbP": "PIP/PBP",
        "OSD": "OSD",

        // OSD相关
        "USB-C充电": "USB-C charging",
        "PIP window": "PIP",
        "PBP window": "PBP",
        "PIP": "PIP",
        "PBP": "PBP",
        /* 固定翻译 -------------------------------------结束 */

        /* 语言包 -------------------------------------开始 */
        "简体中文": "简体中文",
        "英语": "英语",
        /* 语言包 -------------------------------------结束 */
    },
}